/**
 * Code Analysis - 시그니처 도움말 API
 */
import { langServerClient } from '@/shared/api/langserver/client';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import type { AnalysisRequest, SignatureInfo } from './types';

export const fetchSignature = async (
  target: ModuleTarget = 'run',
  payload: AnalysisRequest
): Promise<SignatureInfo[]> => {
  try {
    const response = await langServerClient.post<SignatureInfo[]>(
      `/${target}/api/v1/analysis/template/signature`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Failed to fetch signature:', error);
    return [];
  }
};
